import { forwardRef } from "react";
import PropTypes from "prop-types";

const InputField = forwardRef(
	(
		{
			label,
			type,
			name,
			required = false,
			options = [],
			value,
			onChange,
			onBlur,
			error,
			min,
			placeholder,
			rows = 3, // Default rows for textarea
		},
		ref,
	) => {
		return (
			<div className="mb-4">
				<label
					className="block text-sm font-generalSans font-medium mb-2"
					htmlFor={name}
				>
					{label} {required && <span className="text-red-500">*</span>}
				</label>
				{type === "select" ? (
					<select
						id={name}
						name={name}
						className="w-full p-2 border border-steerBlack rounded-2xl focus:border-steerOrange text-sm"
						value={value || ""}
						onChange={onChange}
						onBlur={onBlur}
						ref={ref}
						required={required}
						aria-label={label}
						aria-required={required}
						aria-invalid={!!error}
					>
						<option value="" disabled={required}>
							Select
						</option>
						{options.map((option, index) => (
							<option
								key={index}
								value={option.value}
								className="text-sm font-generalSans"
							>
								{option.label}
							</option>
						))}
					</select>
				) : type === "textarea" ? (
					<textarea
						id={name}
						name={name}
						className="w-full p-2 border border-steerBlack rounded-2xl text-sm focus:border-steerOrange resize-vertical"
						value={value || ""}
						onChange={onChange}
						onBlur={onBlur}
						ref={ref}
						placeholder={placeholder}
						required={required}
						rows={rows}
						aria-label={label}
						aria-required={required}
						aria-invalid={!!error}
					/>
				) : (
					<input
						id={name}
						type={type}
						name={name}
						className="w-full p-2 border border-steerBlack rounded-2xl text-sm focus:border-steerOrange"
						value={value || ""}
						onChange={onChange}
						onBlur={onBlur}
						ref={ref}
						placeholder={placeholder}
						required={required}
						aria-label={label}
						aria-required={required}
						aria-invalid={!!error}
						{...(type === "date" && { min })}
					/>
				)}
				{error && (
					<p className="text-red-500 text-xs mt-1" role="alert">
						{error}
					</p>
				)}
			</div>
		);
	},
);

InputField.displayName = "InputField";

InputField.propTypes = {
	label: PropTypes.string.isRequired,
	type: PropTypes.string,
	name: PropTypes.string.isRequired,
	required: PropTypes.bool,
	options: PropTypes.array,
	value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	onChange: PropTypes.func.isRequired,
	onBlur: PropTypes.func,
	error: PropTypes.string,
	min: PropTypes.string,
	placeholder: PropTypes.string,
	rows: PropTypes.number, // Number of rows for textarea
};

export default InputField;
